<template>
  <div :class="genitor.filiacao.length ? 'Genitores_header mb-3' : 'semInfo_background' ">
    <div class="Ascendente_title">
      <IconSvg class="familyTree icon--sm"
               icon="familyTree" />
      Ascendentes
    </div>
    <div v-if="genitor.filiacao.length">
      <div v-for="ascendente in genitor.filiacao"
           :key="ascendente.nome"
           class="Ascendente_info">
        {{ ascendente.nome }}
      </div>
    </div>
    <div v-if="!genitor.filiacao.length"
         class="semInfo_text">
      Sem Informação
    </div>
  </div>
</template>

<script>
  export default {
    name: 'BoxAvos',
    props: {
      propGenitor: { type: Object, default: ()=>({}) },
    },
    data () {
      return {
        genitor: {
          filiacao: []
        }
      }
    },
    watch: {
      propGenitor () {
        this.genitor = this.propGenitor
      }
    },
    mounted () {
      if (this.propGenitor.filiacao) this.genitor = this.propGenitor
    }
  }
</script>

<style lang="scss">
  @import '@/scss/_utilities/_exports';
 .Ascendente {
    &_info {
      font-size: 14px;
      font-weight: normal;
      list-style: none;
      padding-left:0.5rem ;

    }

    &_title {
      border-bottom: 0.0625rem solid black;
      margin-bottom: 0.25rem ;
      font-size: 14px;
      font-weight: bold;
    }
  }

.semInfo {
    &_background{
      background-color:#7F7E14;
      padding: 0.5rem;
    }

    &_text{
      font-size: 14px;
      font-weight: bold;
      padding-left:0.5rem ;
    }

  }

.familyTree {
    width: 18.8px;
    height: 18px;
    margin: 0 5.5px 5.5px 5.6px;
  }
  .Genitores_header{
    background-color: #ddd;
    font-size: 1rem;
    font-weight: 500;
    padding: 0.5rem;
  }
</style>
